export const REMOVE_INTEGRATION = 'integrations/REMOVE_INTEGRATION'
export const REMOVE_INTEGRATION_STARTED =
  'integrations/REMOVE_INTEGRATION_STARTED'
export const REMOVE_INTEGRATION_SUCCESS =
  'integrations/REMOVE_INTEGRATION_SUCCESS'
export const REMOVE_INTEGRATION_FAILED =
  'integrations/REMOVE_INTEGRATION_FAILED'

export const ADD_SHOPIFY_STORE = 'integrations/ADD_SHOPIFY_STORE'
export const ADD_SHOPIFY_STORE_STARTED =
  'integrations/ADD_SHOPIFY_STORE_STARTED'
export const ADD_SHOPIFY_STORE_SUCCESS =
  'integrations/ADD_SHOPIFY_STORE_SUCCESS'
export const ADD_SHOPIFY_STORE_FAILED = 'integrations/ADD_SHOPIFY_STORE_FAILED'

export const EDIT_SHOPIFY_STORE = 'integrations/EDIT_SHOPIFY_STORE'
export const EDIT_SHOPIFY_STORE_STARTED =
  'integrations/EDIT_SHOPIFY_STORE_STARTED'
export const EDIT_SHOPIFY_STORE_SUCCESS =
  'integrations/EDIT_SHOPIFY_STORE_SUCCESS'
export const EDIT_SHOPIFY_STORE_FAILED =
  'integrations/EDIT_SHOPIFY_STORE_FAILED'

export const FETCH_INTEGRATIONS = 'integrations/FETCH_INTEGRATIONS'
export const FETCH_INTEGRATIONS_STARTED =
  'integrations/FETCH_INTEGRATIONS_STARTED'
export const FETCH_INTEGRATIONS_SUCCESS =
  'integrations/FETCH_INTEGRATIONS_SUCCESS'
export const FETCH_INTEGRATIONS_FAILED =
  'integrations/FETCH_INTEGRATIONS_FAILED'

export const FETCH_INTEGRATION_SETTINGS_ERROR =
  'integrations/FETCH_INTEGRATION_SETTINGS_ERROR'
export const FETCH_INTEGRATION_SETTINGS_RESPONSE =
  'integrations/FETCH_INTEGRATION_SETTINGS_RESPONSE'
export const FETCH_INTEGRATION_SETTINGS_REQUEST =
  'integrations/FETCH_INTEGRATION_SETTINGS_REQUEST'

export const UPDATE_INTEGRATION_SETTINGS_ERROR =
  'integrations/UPDATE_INTEGRATION_SETTINGS_ERROR'
export const UPDATE_INTEGRATION_SETTINGS_RESPONSE =
  'integrations/UPDATE_INTEGRATION_SETTINGS_RESPONSE'
export const UPDATE_INTEGRATION_SETTINGS_REQUEST =
  'integrations/UPDATE_INTEGRATION_SETTINGS_REQUEST'

export const UPDATE_INTEGRATION_CREDENTIALS_ERROR =
  'integrations/UPDATE_INTEGRATION_CREDENTIALS_ERROR'
export const UPDATE_INTEGRATION_CREDENTIALS_RESPONSE =
  'integrations/UPDATE_INTEGRATION_CREDENTIALS_RESPONSE'
export const UPDATE_INTEGRATION_CREDENTIALS_REQUEST =
  'integrations/UPDATE_INTEGRATION_CREDENTIALS_REQUEST'
